/* global YT */
document.addEventListener('DOMContentLoaded', () => {
    // Dynamically load the YouTube IFrame Player API code.
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Function to handle click events
    const videoClickHandler = (event) => {
        const videoContainer = event.target.closest('.video-section__video-thumb');
        if (videoContainer && !videoContainer.classList.contains('launched')) {
            videoContainer.classList.add('launched');
            const videoId = videoContainer.getAttribute('data-video-id');
            const videoSource = videoContainer.getAttribute('data-video-source');

            // Clear the existing thumbnail or content
            videoContainer.innerHTML = '';

            if (videoSource === 'youtube' && typeof YT !== 'undefined' && YT.Player) {
                const playerDiv = document.createElement('div');
                playerDiv.style.height = '100%';
                videoContainer.appendChild(playerDiv);
                // Create a new YouTube player
                const player = new YT.Player(playerDiv, {
                    height: '100%',
                    width: '100%',
                    videoId,
                    playerVars: {
                        autoplay: 1,
                    },
                    events: {
                        onReady: (e) => {
                            e.target.playVideo();
                        },
                    },
                });
                // eslint-disable-next-line no-console
                console.log(player); // Using player to avoid 'no-new' and 'no-unused-vars' errors
            } else if (videoSource === 'vimeo') {
                // Create an iframe for Vimeo video
                const iframe = document.createElement('iframe');
                iframe.style.width = '100%';
                iframe.style.height = '100%';
                iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
                iframe.frameBorder = '0';
                iframe.allow = 'autoplay; fullscreen';
                iframe.allowFullscreen = true;
                videoContainer.appendChild(iframe);
            } else if (videoSource === 'other') {
                // Handle other video source
                const video = document.createElement('video');
                video.style.width = '100%';
                video.style.height = '100%';
                video.controls = true;

                const source = document.createElement('source');
                source.src = videoId;
                source.type = 'video/mp4';

                video.appendChild(source);
                videoContainer.appendChild(video);
            }
        }
    };

    // Add event listener to the document, listening for clicks within .video-section__video-thumb
    document.addEventListener('click', videoClickHandler);
});

// This function gets called by the YouTube API once it's ready
window.onYouTubeIframeAPIReady = () => {
    // eslint-disable-next-line no-console
    console.log('YouTube IFrame API is ready.');
};
